var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pageMain",attrs:{"id":"app"}},[_c('Header'),_c('router-view',{scopedSlots:_vm._u([{key:"default",fn:function({ Component }){return [_c('transition',{attrs:{"name":"scale-slide","mode":"out-in"}},[_c(Component,{tag:"component"})],1)]}}])}),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }